import React from 'react';
import { FormProvider as Form } from 'react-hook-form';

// ----------------------------------------------------------------------


export default function FormProvider({ children, onSubmit, methods, className }) {
  return (
    <Form {...methods}>
      <form className={className} onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
